import {FETCH_QUOTE} from './quotelistActionTypes'
// import 
export function FetchQuoteDetail(QuoteItem){
    return async (dispatch) => (    
                    dispatch({type:FETCH_QUOTE,payload:QuoteItem})
    );
  }
  
